/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Overall status of the payout:
- `requested`: Payout has been requested but not yet processing
- `processing`: Payout is being processed (may include AML review)
- `completed`: Payout has been successfully completed
- `failed`: Payout failed to process
- `cancelled`: Payout was cancelled

 */
export type PayoutStatus = typeof PayoutStatus[keyof typeof PayoutStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutStatus = {
  requested: 'requested',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;
